"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Cover = _interopRequireDefault(require("./templates/Cover.html"));

var _NoCover = _interopRequireDefault(require("./templates/NoCover.html"));

var _assetMapper = require("../../../../lib/assetMapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _window = window,
    Logger = _window.Logger;

var Cover =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(Cover, _Backbone$View);

  function Cover(_ref) {
    var _this;

    var coverWidths = _ref.coverWidths,
        isInHero = _ref.isInHero,
        _ref$isTitleHistory = _ref.isTitleHistory,
        isTitleHistory = _ref$isTitleHistory === void 0 ? false : _ref$isTitleHistory;

    _classCallCheck(this, Cover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cover).apply(this, arguments));
    _this.coverWidths = _.extend({
      mobile: 145,
      tablet: 160,
      desktop: 190
    }, coverWidths);
    _this.isInHero = isInHero;
    _this.isTitleHistory = isTitleHistory;

    _this.listenTo(_this.model, 'change', _this._render);

    _this._render();

    return _this;
  }

  _createClass(Cover, [{
    key: "remove",
    value: function remove() {
      $(window).off("resize.".concat(this.model.id));
    }
  }, {
    key: "_render",
    value: function _render() {
      var _this2 = this;

      var media = this.model.toJSON();
      var device = detectshun.browser();
      var coverWidth = device.mobile ? this.coverWidths.mobile : device.tablet ? this.coverWidths.tablet : this.coverWidths.desktop;
      var cover = this.model.getCover(coverWidth);

      if (this.model.isPlaceholder) {
        var $cover = "<div class=\"CoverImageContainer\"></div>";
        this.$el.empty().append($cover);
      } else if (cover && cover.href) {
        var _$cover = $((0, _Cover["default"])({
          media: media,
          coverColor: cover && cover.primaryColor && cover.primaryColor.hex || 'inherit',
          src: cover && cover.href,
          href: this.model.titleDetailsUrl,
          label: window.text('cover.coverImageLabel', {
            title: media.title,
            creator: media.firstCreatorName
          }),
          noSampleClass: media.sample.href == null ? 'is-noSample' : ''
        })); // LHTNG-2105: In the event that an image fails to load, wipe out the href's and update the model to trigger a render()


        _$cover.find('img').on('error', function () {
          // LHTNG-2143
          Logger && Logger.log('error', 'CDN Error', {
            type: 'image',
            titleId: media.id,
            src: cover && cover.href
          });
          var imagesRemoved = JSON.parse(JSON.stringify(_this2.model.attributes.covers));

          _(imagesRemoved).each(function (image) {
            delete image.href;
          });

          _this2.model.set({
            covers: imagesRemoved
          });
        });

        this.$el.empty().append(_$cover);
      } else if (this.isTitleHistory) {
        this.$el.empty().append("<a href=\"".concat(this.model.titleDetailsUrl, "\">\n                    <img alt=\"").concat(window.html('coverImageForTitle', {
          title: media.title
        }), "\" class=\"history-noCover\" src=\"").concat((0, _assetMapper.toStaticUrl)("img/no-cover_en_US.jpg"), "\">\n                </a>"));
      } else {
        var creatorText = this.model.isMagazine ? this.model.get('edition') : this.model.get('firstCreatorName');
        this.$el.empty().append((0, _NoCover["default"])({
          media: media,
          href: this.model.titleDetailsUrl,
          isInHero: this.isInHero,
          coverWidth: coverWidth,
          coverHeight: coverWidth * 293 / 220,
          creatorText: creatorText
        }));
        $(window).on("resize.".concat(this.model.id), _.bind(this._manageOverflow, this, '.CoverImageContainer .noCoverAvailable .title', this.model.get('title')));
        $(window).on("resize.".concat(this.model.id), _.bind(this._manageOverflow, this, '.CoverImageContainer .noCoverAvailable .author', creatorText));
        $(window).on("resize.".concat(this.model.id), _.bind(this._resizeClearImage, this)); // timeout gives browser chance to draw and set innerHTML values used

        setTimeout(function () {
          _this2._manageOverflow('.CoverImageContainer .noCoverAvailable .title', _this2.model.get('title'));

          _this2._manageOverflow('.CoverImageContainer .noCoverAvailable .author', creatorText);

          _this2._resizeClearImage();
        }, 1);
      }

      return this;
    }
  }, {
    key: "_resizeClearImage",
    value: function _resizeClearImage() {
      var image = this.el.querySelector('img');

      if (image) {
        $(image).height($(image).parent().width() * 293 / 220);
      }
    }
  }, {
    key: "_manageOverflow",
    value: function _manageOverflow(selector, resetText) {
      var element = this.el.querySelector(selector);

      if (element) {
        element.innerHTML = resetText;

        if (selector.indexOf('.title') !== -1) {
          if ($(element).width() < 100) {
            $(element).css('font-size', '14px');
          } else if ($(element).width() < 125 && $(element).width() >= 100) {
            $(element).css('font-size', '16px');
          } else if ($(element).width() < 150 && $(element).width() >= 125) {
            $(element).css('font-size', '18px');
          } else if ($(element).width() >= 150) {
            $(element).css('font-size', '20px');
          }
        } else if (selector.indexOf('.author') !== -1) {
          if ($(element).width() < 110) {
            $(element).css('font-size', '10px');
          } else if ($(element).width() < 135 && $(element).width() >= 110) {
            $(element).css('font-size', '12px');
          } else if ($(element).width() < 160 && $(element).width() >= 135) {
            $(element).css('font-size', '14px');
          } else if ($(element).width() >= 160) {
            $(element).css('font-size', '16px');
          }
        }

        if (element.scrollHeight > 0 && element.scrollHeight > element.clientHeight) {
          var text = element.innerHTML;
          text = "".concat(text.replace(/\W+$/g, ''), "..."); // remove trailing special characters and add ellipsis

          while (text !== '...' && element.scrollHeight > element.clientHeight) {
            text = text.replace(/\W*\w\W*(\.{3})$/g, '$1'); // remove a non-ellipsis character and unwanted characters around itΩ

            element.innerHTML = text;
          } // todo: put a min width an height on this! We know what the heights are for particular screen widths

        }
      }
    }
  }]);

  return Cover;
}(Backbone.View);

exports["default"] = Cover;